// See https://developer.mastercard.com/src/documentation/faqs/ for supported browsers
var notSupportedBrowsers = ["ios-webview", "chromium-webview"];
export default notSupportedBrowsers;
